import React from "react";
import { Card, Typography, Button } from "antd";

const { Title, Paragraph } = Typography;

const MethodCard = ({
  icon,
  title,
  subtitle,
  bullets,
  buttonText,
  buttonIcon,
  onClick,
}) => {
  return (
    <>
      <style>
        {`
          .method-card {
            border-radius: 16px !important;
            padding: 24px !important;
            border: 2px solid #D7EDEE !important;
            background: linear-gradient(180deg, #ffffff, #f9fdfd) !important;
            transition: all 0.25s ease !important;
            cursor: pointer;
            width: 100%;
          }
          .method-card:hover {
            transform: translateY(-6px);
            box-shadow: 0 10px 24px rgba(0,0,0,0.12);
          }
          @media (max-width: 480px) {
            .method-card {
              padding: 14px !important;
            }
          }
        `}
      </style>

      <Card bordered={false} className="method-card" bodyStyle={{ padding: 0 }}>
        <div style={{ textAlign: "center", fontSize: 40, color: "#0F8F8F" }}>
          {icon}
        </div>

        <Title
          level={4}
          style={{ fontSize: "20px", textAlign: "center", marginTop: 16 }}
        >
          {title}
        </Title>

        <Paragraph
          style={{
            fontSize: "12px",
            textAlign: "center",
            background: "#E6F4F1",
            padding: "6px 0",
            borderRadius: 10,
            color: "#0C6F6F",
            margin: "12px 0",
          }}
        >
          {subtitle}
        </Paragraph>

        <div style={{ marginTop: 20 }}>
          <Paragraph strong>✓ What we'll verify:</Paragraph>
          <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
            {bullets.map((item, idx) => (
              <li key={idx} style={{ marginBottom: 6 }}>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <Button
          type="primary"
          block
          size="large"
          icon={buttonIcon}
          style={{
            marginTop: 24,
            background: "#0F8F8F",
            borderColor: "#0F8F8F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </Card>
    </>
  );
};

export default MethodCard;
